import { Link } from "wouter";
import { ArrowLeft, Bot } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function Impressum() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-card to-background">
      <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container flex h-16 items-center justify-between px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2">
            <Bot className="h-6 w-6 sm:h-8 sm:w-8 text-primary" />
            <span className="text-lg sm:text-xl font-bold text-primary font-playfair">Social Media A-Team</span>
          </div>
          <Link href="/">
            <Button variant="ghost" size="sm" data-testid="button-back-home">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Zurück
            </Button>
          </Link>
        </div>
      </header>

      <main className="container px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-4 sm:p-6 lg:p-8 space-y-8">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-playfair text-primary" data-testid="text-impressum-title">
              Impressum
            </h1>

            <section className="space-y-4">
              <h2 className="text-lg sm:text-xl font-semibold text-foreground">
                Angaben gemäß § 5 TMG
              </h2>
              <div className="text-muted-foreground space-y-1">
                <p className="font-medium text-foreground">MikeGee</p>
                <p>SumoBrands UG (haftungsbeschränkt)</p>
                <p>Plektrudisstr. 6</p>
                <p>50354 Hürth</p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-lg sm:text-xl font-semibold text-foreground">
                Kontakt
              </h2>
              <div className="text-muted-foreground space-y-1">
                <p>Telefon: +49 2233 6290626</p>
                <p>E-Mail: <a href="mailto:Info@sumobrands.ai" className="text-primary hover:underline">Info@sumobrands.ai</a></p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-lg sm:text-xl font-semibold text-foreground">
                Streitschlichtung
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                  <a 
                    href="https://ec.europa.eu/consumers/odr" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline break-all"
                  >
                    https://ec.europa.eu/consumers/odr
                  </a>
                </p>
                <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
                <p>
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-lg sm:text-xl font-semibold text-foreground">
                Haftung für Inhalte
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                  nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als 
                  Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde 
                  Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige 
                  Tätigkeit hinweisen.
                </p>
                <p>
                  Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den 
                  allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch 
                  erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei 
                  Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-lg sm:text-xl font-semibold text-foreground">
                Haftung für Links
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen 
                  Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                  Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
                  Seiten verantwortlich.
                </p>
                <p>
                  Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße 
                  überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. 
                  Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete 
                  Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von 
                  Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-lg sm:text-xl font-semibold text-foreground">
                Urheberrecht
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                  dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                  der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
                  Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite 
                  sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
                </p>
                <p>
                  Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die 
                  Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche 
                  gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, 
                  bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen 
                  werden wir derartige Inhalte umgehend entfernen.
                </p>
              </div>
            </section>

            <hr className="border-border" />

            <section className="space-y-4">
              <h2 className="text-lg sm:text-xl font-semibold text-foreground">
                Site Notice (English)
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p className="font-medium text-foreground">
                  Information provided according to Sec. 5 German Telemedia Act (TMG)
                </p>
                <p>Mike Gierlich</p>
                <p>SumoBrands UG (haftungsbeschränkt)</p>
                <p>Plektrudisstr. 6</p>
                <p>50354 Hürth</p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-lg sm:text-xl font-semibold text-foreground">
                Contact
              </h2>
              <div className="text-muted-foreground space-y-1">
                <p>Telephone: +49 2233 6290626</p>
                <p>Email: <a href="mailto:Info@sumobrands.ai" className="text-primary hover:underline">Info@sumobrands.ai</a></p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-lg sm:text-xl font-semibold text-foreground">
                Dispute Resolution
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  The European Commission provides a platform for online dispute resolution (OS):{" "}
                  <a 
                    href="https://ec.europa.eu/consumers/odr" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-primary hover:underline break-all"
                  >
                    https://ec.europa.eu/consumers/odr
                  </a>
                </p>
                <p>Please find our email in the impressum/legal notice.</p>
                <p>We do not take part in online dispute resolutions at consumer arbitration boards.</p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-lg sm:text-xl font-semibold text-foreground">
                Liability for Contents
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  As service providers, we are liable for own contents of these websites according to 
                  Sec. 7, paragraph 1 German Telemedia Act (TMG). However, according to Sec. 8 to 10 
                  German Telemedia Act (TMG), service providers are not obligated to permanently monitor 
                  submitted or stored information or to search for evidences that indicate illegal activities.
                </p>
                <p>
                  Legal obligations to removing information or to blocking the use of information remain 
                  unchallenged. In this case, liability is only possible at the time of knowledge about 
                  a specific violation of law. Illegal contents will be removed immediately at the time 
                  we get knowledge of them.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-lg sm:text-xl font-semibold text-foreground">
                Liability for Links
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  Our offer includes links to external third party websites. We have no influence on the 
                  contents of those websites, therefore we cannot guarantee for those contents. Providers 
                  or administrators of linked websites are always responsible for their own contents.
                </p>
                <p>
                  The linked websites had been checked for possible violations of law at the time of the 
                  establishment of the link. Illegal contents were not detected at the time of the linking. 
                  A permanent monitoring of the contents of linked websites cannot be imposed without 
                  reasonable indications that there has been a violation of law. Illegal links will be 
                  removed immediately at the time we get knowledge of them.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-lg sm:text-xl font-semibold text-foreground">
                Copyright
              </h2>
              <div className="text-muted-foreground space-y-3">
                <p>
                  Contents and compilations published on these websites by the providers are subject to 
                  German copyright laws. Reproduction, editing, distribution as well as the use of any 
                  kind outside the scope of the copyright law require a written permission of the author 
                  or originator. Downloads and copies of these websites are permitted for private use only. 
                  The commercial use of our contents without permission of the originator is prohibited.
                </p>
                <p>
                  Copyright laws of third parties are respected as long as the contents on these websites 
                  do not originate from the provider. Contributions of third parties on this site are 
                  indicated as such. However, if you notice any violations of copyright law, please inform 
                  us. Such contents will be removed immediately.
                </p>
              </div>
            </section>
          </CardContent>
        </Card>
      </main>

      <footer className="border-t border-border/40 py-6 sm:py-8 mt-8">
        <div className="container px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="flex items-center space-x-2">
              <Bot className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />
              <span className="font-semibold text-primary font-playfair text-sm sm:text-base">Social Media A-Team</span>
            </div>
            <div className="flex flex-wrap justify-center gap-4 text-xs sm:text-sm text-muted-foreground">
              <span>© 2025 SumoBrands</span>
              <Link href="/impressum" className="hover:text-primary hover:underline" data-testid="link-footer-impressum">
                Impressum
              </Link>
              <Link href="/datenschutz" className="hover:text-primary hover:underline" data-testid="link-footer-datenschutz">
                Datenschutz
              </Link>
              <Link href="/agb" className="hover:text-primary hover:underline" data-testid="link-footer-agb">
                AGB
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
